export function copyObject(data: any) {
    return Object.assign({}, data);
}

export function deepCopyObject(data: any) {
    return JSON.parse(JSON.stringify(data));
}

export function isObject(obj: any) {
    if (obj && !!Object.keys(obj).length) {
        return true;
    }
    return false;
}
